import useTwinTranslation from '../useTwinTranslation'
import { TwinIconProp } from '../../../baseComponents/TwinIcon'
import { faClock, faFileCheck, faFileSlash } from '@fortawesome/pro-light-svg-icons'
import { BankRemittanceStatusKeys } from '@teinor/erp/types/company/accounting/bankRemittance'

interface BankRemittanceStatusTy {
    name: string
    colorText: string
    icon: TwinIconProp
}
const useBankRemittanceStatus = () => {
    const { t } = useTwinTranslation()
    const bankRemittanceStatus: Record<BankRemittanceStatusKeys, BankRemittanceStatusTy> = {
        0: { name: t('pendentS', 'Pendiente'), colorText: 'text-gray-2E', icon: faClock },
        1: { name: t('finished', 'Finalizado'), colorText: 'text-green-21', icon: faFileCheck },
        2: { name: t('cancelled', 'Cancelado'), colorText: 'text-red-BA', icon: faFileSlash },
    }

    return { bankRemittanceStatus }
}

export default useBankRemittanceStatus